import { AgxApi } from '../../helpers/http';

export interface DevProgressContractWorkflowRequest {
  campaignId: string;
  contractId: string;
  status: string;
}

export const activitiesApi = (authToken: string) =>
  new AgxApi('activities', authToken);

export const progressDevContractWorkflow = async (
  authToken: string,
  request: DevProgressContractWorkflowRequest
) => {
  await activitiesApi(authToken).post('DevProgressContractWorkflow', request);
};
